export const HeaderSetAboutPanelRequestedAction = 'HeaderSetAboutPanelRequestedAction'

export const aboutPanelRequestedAction = (requested) => {
    return {
        type: HeaderSetAboutPanelRequestedAction,
        payload: requested
    }
}
